import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';

// Second-level nav above a nested route's content. tabs: [{ to, label, end? }]
function SubTabsLayout({ tabs }) {
  return (
    <div>
      <nav className="subtabs">
        {tabs.map(tab => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            className={({ isActive }) => `subtab-button ${isActive ? 'active' : ''}`}
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}

export default SubTabsLayout;
